import React, { useState, memo, useEffect } from "react";
import PropTypes from "prop-types";

import {
  parseXML,
  // getSortedObj,
  flatObject,
  isEmpty
} from "../../formwidgets/remotelookup/lookuputils";

import styles from "./style.css";

export function RemoteLookupRenderer(props) {
  var { value, column } = props;
  const type = column.modelConfig.RemoteLookupTrigger.toLowerCase() || "";
  const resultType =
    column && column.modelConfig && column.modelConfig.RemoteLookupResultType
      ? column.modelConfig.RemoteLookupResultType
      : null;
  const formatValue = (value) => {
    if (
      column.modelConfig.RemoteLookupResultType &&
      column.modelConfig.RemoteLookupResultType === "XML" &&
      value
    ) {
      return parseXML(value);
    }
    // Ignoring sorting for both JSON and Text responses
    // else if (
    //   column.modelConfig.RemoteLookupResultType &&
    //   column.modelConfig.RemoteLookupResultType === "JSON" &&
    //   value
    // ) {
    //   return getSortedObj(value);
    // }
    return value;
  };
  const [currentValue, setCurrentValue] = useState(formatValue(value));

  useEffect(
    function updateCurrentValue() {
      if (!isEmpty(value)) {
        let newValue = {};
        var sourceObj = value;
        if (typeof value === "string" && resultType !== "Text") {
          sourceObj = formatValue(value);
        }
        if (resultType !== "Text") {
          flatObject(sourceObj, newValue);
          if (Object.keys(newValue).length > 0) {
            let _key = Object.keys(newValue)[0];
            let _value = newValue[_key];
            setCurrentValue({ key: _key, val: _value });
          }
        } else {
          setCurrentValue(sourceObj);
        }
      } else {
        setCurrentValue("");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );
  if (
    resultType !== "Text" &&
    (type === "auto" || type === "manual") &&
    currentValue &&
    Object.keys(currentValue).length > 0
  ) {
    return (
      <pre className={`${value ? styles.remoteLookup : ""} ellipsis`}>
        {currentValue.key}: <strong>{currentValue.val}</strong>
      </pre>
    );
  } else if (resultType === "Text" && currentValue) {
    return (
      <div className={`${styles.remoteLookup} ellipsis`}>{currentValue}</div>
    );
  }

  return null;
}

RemoteLookupRenderer.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any
};

export const RemoteLookup = memo(RemoteLookupRenderer);
